import { render } from "./ConfirmModalComponent.vue?vue&type=template&id=a0c4d1fa&scoped=true&ts=true"
import script from "./ConfirmModalComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmModalComponent.vue?vue&type=script&lang=ts"

import "./ConfirmModalComponent.vue?vue&type=style&index=0&id=a0c4d1fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c4d1fa"]])

export default __exports__